import { FC } from 'react'
import { Heading, HeadingLevel, HeadingTag, IconButton, IconButtonFunction, IconName } from '@enbw/ui-react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import { InTerminationMessageCard, TerminatedMessageCard } from './components'
import { FlyoutMessages, FlyoutMessageType } from '@/domain/contract/types/messages'

type ContractMessagesFlyoutProps = {
  messages: FlyoutMessages
  onClose: () => void
}

export const ContractMessagesFlyout: FC<ContractMessagesFlyoutProps> = ({ messages, onClose }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.flyoutCard}>
      <div className={styles.flyoutHeader}>
        <div className={styles.flyoutHeaderTitles}>
          <Heading level={HeadingLevel.H3} tag={HeadingTag.H3}>
            {t('contract.messagesFlyout.title')}
          </Heading>
          <Heading level={HeadingLevel.H3} tag={HeadingTag.H3} className={styles.messagesFlyoutTitleNumber}>
            {messages.messages.length}
          </Heading>
        </div>

        <IconButton name={IconName.CloseLarge} function={IconButtonFunction.Tertiary} onClick={onClose} />
      </div>

      <div className={styles.flyoutContent}>
        {messages.messages.map((message) => {
          switch (message.type) {
            case FlyoutMessageType.InTermination:
              return <InTerminationMessageCard key={FlyoutMessageType.InTermination} message={message} />
            case FlyoutMessageType.Terminated:
              return <TerminatedMessageCard key={FlyoutMessageType.Terminated} message={message} />
          }
        })}
      </div>
    </div>
  )
}
